import { sidebarButtons, mainGroups } from '../dashboard-data.ts';
import { setupIidSearch } from '../iid-handler.ts';
import { sb } from '../supabase.ts';
import { escapeHtml } from '../main.ts';
import { backupToSupabaseBackup } from '../supabase-backup.ts';
import { BACKUP_TABLES } from '../cloudflare-backup.ts';

export async function renderDashboardPage(app: HTMLElement): Promise<void> {
  const { data: { session } } = await sb.auth.getSession();
  const userEmail = session?.user?.email || 'admin@fenimodel.school';
  const isAuthorizedToBackup = userEmail === 'gopalsdiary@gmail.com';

  app.innerHTML = `
    <div class="container fluid">
      <!-- Colorful User Greeting Banner -->
      <div class="user-greeting-banner" style="
        background: linear-gradient(135deg, #0ea5e9, #a855f7, #ec4899);
        padding: 1rem 1.75rem;
        border-radius: var(--radius);
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
        box-shadow: 0 10px 30px rgba(14, 165, 233, 0.15);
        position: relative;
        overflow: hidden;
      ">
        <div style="position: absolute; top: -50px; right: -50px; width: 150px; height: 150px; background: rgba(255,255,255,0.15); border-radius: 50%; filter: blur(30px); pointer-events: none;"></div>
        <div style="position: absolute; bottom: -30px; left: 10%; width: 100px; height: 100px; background: rgba(255,255,255,0.1); border-radius: 50%; filter: blur(20px); pointer-events: none;"></div>

        <div style="display: flex; flex-direction: column; gap: 4px; z-index: 1;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 20px; line-height: 1;">🏫</span>
            <h1 style="
              font-size: 18px;
              font-weight: 850;
              letter-spacing: 0.03em;
              margin: 0;
              color: #ffffff;
              text-shadow: 0 2px 4px rgba(0,0,0,0.1);
              font-family: 'Outfit', 'Sora', sans-serif;
            ">FENI MODEL HIGH SCHOOL</h1>
          </div>
          <div style="display: flex; align-items: center; gap: 8px; margin-top: 4px; background: rgba(255, 255, 255, 0.12); padding: 4px 10px; border-radius: 20px; border: 1px solid rgba(255,255,255,0.15); width: fit-content; backdrop-filter: blur(4px);">
            <span style="font-size: 12px; line-height: 1;">👤</span>
            <span style="font-size: 12px; font-weight: 600; color: rgba(255, 255, 255, 0.95);">${escapeHtml(userEmail)}</span>
            <span style="width: 4px; height: 4px; border-radius: 50%; background: rgba(255, 255, 255, 0.5);"></span>
            <span style="font-size: 9px; font-weight: 700; color: #ffe2e2; text-transform: uppercase; letter-spacing: 0.05em; white-space: nowrap;">Super Admin</span>
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 12px; z-index: 1;">
          ${isAuthorizedToBackup ? `
          <button id="backupBtn" style="
            background: rgba(255, 255, 255, 0.15);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #fff;
            padding: 8px 16px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            backdrop-filter: blur(4px);
          " onmouseover="this.style.background='rgba(255,255,255,0.25)'; this.style.transform='translateY(-1px)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'; this.style.transform='translateY(0)'">
            <span>Backup</span>
            <span style="font-size: 14px; line-height: 1;">💾</span>
          </button>
          <button id="downloadBtn" style="
            background: rgba(255, 255, 255, 0.15);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #fff;
            padding: 8px 16px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            backdrop-filter: blur(4px);
          " onmouseover="this.style.background='rgba(255,255,255,0.25)'; this.style.transform='translateY(-1px)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'; this.style.transform='translateY(0)'">
            <span>Download csv</span>
            <span style="font-size: 14px; line-height: 1;">📥</span>
          </button>
          ` : ''}
          <button id="logoutBtn" style="
            background: rgba(255, 255, 255, 0.15);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #fff;
            padding: 8px 16px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            backdrop-filter: blur(4px);
          " onmouseover="this.style.background='rgba(255,255,255,0.25)'; this.style.transform='translateY(-1px)'" onmouseout="this.style.background='rgba(255,255,255,0.15)'; this.style.transform='translateY(0)'">
            <span>Logout</span>
            <span style="font-size: 14px; line-height: 1;">🚪</span>
          </button>
        </div>
      </div>

      <div class="dashboard-layout">
        <aside class="sidebar card bento-item">
          <div class="sidebar-header">
            <h2 style="font-size: 1.1rem; font-weight: 800; color: var(--primary); margin-top: 0; margin-bottom: 12px;">Quick Actions</h2>
          </div>
          <div class="sidebar-buttons">
            ${sidebarButtons.map(btn => `
              <a href="${btn.href}" class="sidebar-btn">${btn.label}</a>
            `).join('')}
          </div>
          
          <div class="search-box" style="margin-top: 1.25rem;">
            <label style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: var(--muted);">Search by IID</label>
            <div style="display: flex; gap: 8px; margin-top: 8px;">
              <input type="text" id="iidInput" class="table-input" placeholder="Enter IID...">
              <button id="iidSearchBtn" class="btn">Go</button>
            </div>
            <div id="searchStatus" style="font-size: 11px; margin-top: 4px; min-height: 14px;"></div>
          </div>
        </aside>

        <main class="main-content card bento-item">
          <div class="section-header">
            <h2 style="font-weight: 800;">Administrative Dashboard</h2>
            <div class="pill">Systems Active</div>
          </div>
          
          <div class="cluster-grid">
            ${mainGroups.map(group => `
              <div class="cluster-card">
                <div class="cluster-title">
                  <h3 style="font-weight: 700;">${group.title}</h3>
                  <span class="pill" style="font-size: 10px;">${group.pill}</span>
                </div>
                <div style="display: flex; flex-direction: column; gap: 6px;">
                  ${group.links.map(link => {
                    const isEditByIid = link.label === 'Edit by IID';
                    const clickAttr = isEditByIid ? `onclick="window.showEditByIidModal(event)"` : '';
                    return `
                      <a href="${link.href}" ${clickAttr} class="sidebar-btn" style="background: transparent; box-shadow: none; border-color: rgba(0,0,0,0.05);">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                          <span>${link.label}</span>
                          ${link.badge ? `<span class="badge ${link.badgeClass}" style="font-size: 10px; padding: 2px 6px;">${link.badge}</span>` : ''}
                        </div>
                      </a>
                    `;
                  }).join('')}
                </div>
              </div>
            `).join('')}
          </div>
        </main>
      </div>
    </div>

    <!-- Edit by IID Modal -->
    <div id="editByIidModal" style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(15, 23, 42, 0.4);
      backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.25s ease;
    ">
      <div class="modal-content card" style="
        width: 100%;
        max-width: 400px;
        background: #fff;
        border-radius: 16px;
        padding: 32px;
        box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
        transform: scale(0.95);
        transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
        box-sizing: border-box;
      ">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <h3 style="font-size: 18px; font-weight: 700; color: #1e293b; margin: 0; display: flex; align-items: center; gap: 8px;">
            📝 Edit Student by IID
          </h3>
          <button style="background: none; border: none; font-size: 24px; color: #64748b; cursor: pointer; line-height: 1; padding: 4px; transition: color 0.2s;" onclick="window.closeEditByIidModal()">&times;</button>
        </div>
        <form id="editByIidForm">
          <div style="display: flex; flex-direction: column; gap: 8px;">
            <label style="font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase;">Student IID</label>
            <input type="text" id="popupIidInput" required placeholder="e.g. 2601001" style="
              padding: 10px;
              border: 1px solid #cbd5e1;
              border-radius: 8px;
              font-size: 14px;
              width: 100%;
              box-sizing: border-box;
              transition: border-color 0.2s, box-shadow 0.2s;
            ">
            <div id="popupSearchStatus" style="font-size: 12px; min-height: 16px; margin-top: 4px; color: #64748b;"></div>
          </div>
          <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
            <button type="button" class="btn" style="background: #cbd5e1; color: #475569; margin: 0;" onclick="window.closeEditByIidModal()">Cancel</button>
            <button type="submit" class="btn" style="background: var(--primary, #0061f2); color: #fff; margin: 0;">Search & Edit</button>
          </div>
        </form>
      </div>
    </div>
  `;

  // Dynamic window actions for the popup modal
  (window as any).showEditByIidModal = (e: Event) => {
    e.preventDefault();
    const modal = document.getElementById('editByIidModal')!;
    modal.style.opacity = '1';
    modal.style.pointerEvents = 'auto';
    const content = modal.querySelector('.modal-content') as HTMLElement;
    content.style.transform = 'scale(1)';
    const input = document.getElementById('popupIidInput') as HTMLInputElement;
    input.value = '';
    input.focus();
    const status = document.getElementById('popupSearchStatus')!;
    status.textContent = '';
    status.className = '';
  };

  (window as any).closeEditByIidModal = () => {
    const modal = document.getElementById('editByIidModal')!;
    modal.style.opacity = '0';
    modal.style.pointerEvents = 'none';
    const content = modal.querySelector('.modal-content') as HTMLElement;
    content.style.transform = 'scale(0.95)';
  };

  // Close modal when clicking on the backdrop overlay
  const modalElement = document.getElementById('editByIidModal')!;
  modalElement.addEventListener('click', (e) => {
    if (e.target === modalElement) {
      (window as any).closeEditByIidModal();
    }
  });

  // Handle Edit by IID form validation and redirection
  const form = document.getElementById('editByIidForm') as HTMLFormElement;
  form.onsubmit = async (e) => {
    e.preventDefault();
    const input = document.getElementById('popupIidInput') as HTMLInputElement;
    const val = input.value.trim();
    if (!val) return;

    const status = document.getElementById('popupSearchStatus')!;
    status.textContent = 'Searching database...';
    status.style.color = '#64748b';

    try {
      const { sb } = await import('../supabase.ts');
      const { data, error } = await sb
        .from('student_database')
        .select('iid')
        .eq('iid', Number(val))
        .single();

      if (error || !data) {
        status.textContent = '❌ Student IID not found in database.';
        status.style.color = '#ef4444';
        return;
      }

      status.textContent = '✅ Found! Redirecting...';
      status.style.color = '#10b981';

      setTimeout(() => {
        (window as any).closeEditByIidModal();
        const url = `/edit_details?iid=${encodeURIComponent(val)}`;
        window.open(url, '_blank', 'noopener');
      }, 500);

    } catch (err) {
      console.error(err);
      status.textContent = '❌ Search failed. Please try again.';
      status.style.color = '#ef4444';
    }
  };

  setupIidSearch('iidInput', 'iidSearchBtn');

  const backupBtn = document.getElementById('backupBtn');
  if (backupBtn && isAuthorizedToBackup) {
    const btnSpan = backupBtn.querySelector('span') as HTMLSpanElement;
    const originalText = 'Backup';
    backupBtn.onclick = async () => {
      backupBtn.setAttribute('disabled', 'true');
      backupBtn.style.opacity = '0.6';
      backupBtn.style.pointerEvents = 'none';

      try {
        // Run Supabase backup
        await backupToSupabaseBackup((msg) => {
          btnSpan.textContent = `Supa: ${msg}`;
        });

        btnSpan.textContent = 'Backup Success! 🎉';
        
        // Save overall success timestamp
        localStorage.setItem('d1_backup_overall_success_timestamp', Date.now().toString());

        // Reset button properties after 2 seconds showing success message
        setTimeout(() => {
          btnSpan.textContent = originalText;
          backupBtn.removeAttribute('disabled');
          backupBtn.style.opacity = '1';
          backupBtn.style.pointerEvents = 'auto';
        }, 2000);

      } catch (err: any) {
        console.error(err);
        btnSpan.textContent = 'Backup Failed ❌';
        alert('Backup Failed:\n' + err.message);
        setTimeout(() => {
          btnSpan.textContent = originalText;
          backupBtn.removeAttribute('disabled');
          backupBtn.style.opacity = '1';
          backupBtn.style.pointerEvents = 'auto';
        }, 3000);
      }
    };
  }

  const downloadBtn = document.getElementById('downloadBtn');
  if (downloadBtn && isAuthorizedToBackup) {
    const btnSpan = downloadBtn.querySelector('span') as HTMLSpanElement;
    const originalText = 'Download';

    downloadBtn.onclick = async () => {
      downloadBtn.setAttribute('disabled', 'true');
      downloadBtn.style.opacity = '0.6';
      downloadBtn.style.pointerEvents = 'none';

      try {
        for (let i = 0; i < BACKUP_TABLES.length; i++) {
          const tableName = BACKUP_TABLES[i];
          btnSpan.textContent = `Fetching ${tableName}...`;

          const rows: any[] = [];
          let page = 0;
          const pageSize = 1000;
          while (true) {
            const { data, error } = await sb
              .from(tableName)
              .select('*')
              .range(page * pageSize, (page + 1) * pageSize - 1);

            if (error) {
              throw new Error(`Failed to fetch ${tableName}: ${error.message}`);
            }
            if (!data || data.length === 0) {
              break;
            }
            rows.push(...data);
            if (data.length < pageSize) {
              break;
            }
            page++;
          }

          btnSpan.textContent = `CSV: ${tableName}...`;
          
          let csvContent = '';
          if (rows.length > 0) {
            const keys = Array.from(new Set(rows.flatMap(item => Object.keys(item))));
            const csvRows = [];
            csvRows.push(keys.map(key => `"${String(key).replace(/"/g, '""')}"`).join(','));

            for (const row of rows) {
              const values = keys.map(key => {
                const val = row[key];
                if (val === null || val === undefined) {
                  return '';
                }
                const valStr = typeof val === 'object' ? JSON.stringify(val) : String(val);
                return `"${valStr.replace(/"/g, '""')}"`;
              });
              csvRows.push(values.join(','));
            }
            csvContent = csvRows.join('\n');
          } else {
            csvContent = 'No data available';
          }

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${tableName}_backup_${new Date().toISOString().split('T')[0]}.csv`;
          a.click();
          URL.revokeObjectURL(url);

          await new Promise(resolve => setTimeout(resolve, 500));
        }

        btnSpan.textContent = 'All Downloaded! 🎉';
        setTimeout(() => {
          btnSpan.textContent = originalText;
          downloadBtn.removeAttribute('disabled');
          downloadBtn.style.opacity = '1';
          downloadBtn.style.pointerEvents = 'auto';
        }, 3000);

      } catch (err: any) {
        console.error(err);
        btnSpan.textContent = 'Failed ❌';
        alert('Download Failed:\n' + err.message);
        setTimeout(() => {
          btnSpan.textContent = originalText;
          downloadBtn.removeAttribute('disabled');
          downloadBtn.style.opacity = '1';
          downloadBtn.style.pointerEvents = 'auto';
        }, 3000);
      }
    };
  }

  const logoutBtn = document.getElementById('logoutBtn');
  if (logoutBtn) {
    logoutBtn.onclick = async () => {
      await sb.auth.signOut();
      window.location.href = '/login';
    };
  }
}
